import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
//validators
import {validateField} from '../common/redux/validators';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';


//Para los select
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';


/*Material ui template */
import Grid from '@material-ui/core/Grid';



class ConfigureCompany extends React.Component {
  state = {
    buttonDisabled:false,
    errores:{},
    configure:{}
  };

  constructor(props)
  {
    super(props);
    //bindings
    this.changeStatus = this.changeStatus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  changeStatus()
  {
     if (!this.validateForm()) 
      {
        this.setState({completion_date_error: 'Please enter the require fields'});
        return;
      }
      this.setState({buttonDisabled:true});
      //Vamos a editar/crear Componen
      this.props.actions.setupConfiguration(this.state.configure)
      .then(res=>{
        this.handleClose();
      });
  }
  
  handleClose()
  {
    this.props.handleClose();
  }

  onEnter()
  {
    this.setState({
      configure:this.props.company_selected,
      buttonDisabled:false,
      errores:{}
    });
  }

  handleChange(event)
  {
    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let configure = this.state.configure;
    configure[name] = value;

    this.setState({
      configure: configure,
    });
    this.validateForm();
  }


  validateForm = ()=>
  {
    let errores = {};
    let valido = true;
    let configure = {
      expiration:'',
      users_limit:'',
      projects_limit:'',
      cost_limit:''
    };

    //Validando atributos almenos ingresados
    for (const attribute in configure) 
    {
      if (!validateField(this.state.configure[attribute])) 
      {
        errores[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }
    if(isNaN(parseInt(this.state.configure.users_limit,10)) || parseInt(this.state.configure.users_limit,10) <0)
    {
      errores["users_limit"]= 'Must be a positive number';
      valido = false;
    }

    if(isNaN(parseInt(this.state.configure.projects_limit,10)) || parseInt(this.state.configure.projects_limit,10) <0)
    {
      errores["projects_limit"]= 'Must be a positive number';
      valido = false;
    }

    this.setState({
      errores: errores,
    });
    return valido;
  }

  
  render() {
    return (
      <div>
        <Dialog
          style={{minWidth:"400px", minHeight:"400px"}}

          fullWidth={true}
          maxWidth={"md"}
          open={this.props.open}
          onClose={this.props.handleClose}
          onEnter={this.onEnter}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Setup Company</DialogTitle>
          <DialogContent>

          <Grid item xs={12}>
            <div style={{marginTop:'5%'}}>
              <InputLabel htmlFor="expiration" style={{marginRight:'10px'}}>Expiration</InputLabel>
              <Select
                required
                fullWidth
                id="expiration"
                name="expiration"
                value={this.state.configure.expiration}
                onChange={this.handleChange}
                error={this.state.errores.expiration}
                helperText={this.state.errores.expiration}
              >
                <MenuItem native="true" key={1} value={1} selected>
                  Six Months
                </MenuItem>
                <MenuItem native="true" key={2} value={2}>
                  Never
                </MenuItem>
              </Select>
            </div>
          </Grid>
          
          <Grid item xs={12} style={{marginTop:"30px"}}>
            <TextField
              fullWidth
              required
              id="users_limit"
              label="Users:"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={this.handleChange}
              value={this.state.configure.users_limit}
              error={this.state.errores.users_limit}
              helperText={this.state.errores.users_limit}
            />
          </Grid>

          <Grid item xs={12} style={{marginTop:"30px"}}>
            <TextField
              fullWidth
              required
              id="projects_limit"
              label="Projects:"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={this.handleChange}
              value={this.state.configure.projects_limit}
              error={this.state.errores.projects_limit}
              helperText={this.state.errores.projects_limit}
            />
          </Grid>
          <Grid item xs={12}>
            <div style={{marginTop:'5%'}}>
              <InputLabel htmlFor="cost_limit" style={{marginRight:'10px'}}>Cost Limit</InputLabel>
              <Select
                required
                fullWidth
                id="cost_limit"
                name="cost_limit"
                value={this.state.configure.cost_limit}
                onChange={this.handleChange}
                error={this.state.errores.cost_limit}
                helperText={this.state.errores.cost_limit}
              >
                <MenuItem native="true" key={1} value={1} selected>
                  less than 10M
                </MenuItem>
                <MenuItem native="true" key={2} value={2}>
                  Greater than 10M 
                </MenuItem>
              </Select>
            </div>
          </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.changeStatus} color="primary"  disabled={this.state.buttonDisabled}>
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    company: state.company,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)((ConfigureCompany));


// WEBPACK FOOTER //
// ./src/features/company/ConfigureCompany.js